<template>
  <div id="work_gallery_detail">
    <div id='work_gallery_detail-contents'>
      <span class="slideIn title"><h1>{{ detailTitle }}</h1></span>
      <span class="slideIn yearLoction"> {{ detailYear }} / {{detailLocation}}</span>
      <span class="slideIn detail"> {{ detailDetail }}</span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import gsap from "gsap";


const galleryList = [

  /* #1 */
  {
    title: "2D -> 3D Pose estimation", 
    year: 2020,
    location: 'New York, United State',
    detail: "Architected and developed prototype app to demonstrate 2D -> 3D Pose Rigging using Machine Learning to estimate. \
    Tensorflow, Python, Flask, Redis, VueJS, C++, Unity"
  },

  /* #2 */
  {
    title: "OpenCV Segmentation & OpenFramework graphics", 
    year: 2020,
    location: 'New York, United State',
    detail: "Computer Vision Library Open CV ( C++ ) application using OpenFrameworks and UI using shader for P5.js"
  },
  /* #3 */

  {
    title: "OpenCV  Human segmentation using Syphen pipeline for shader", 
    year: 2020,
    location: 'New York, United State',
    detail: "Moving Object Segmentation to estimate segmentation. Create baseline for graphics to apply through Syphon protocol to perform interactive particle display"
  },

  /* #4 */

  {
    title: "Developed Cross Platform App Building Studio", 
    year: 2019,
    location: 'IL, FL, Tokyo, United State, Japan',
    detail: "Developed drag and drop cross platform app builder. As an R&D Lead, developed pluggable modules for Face Recognition, BlueTooth Printer, \
             Bose AR modules. \
             RoR, Android, IOS, Objective C, Java, C / C++, HTML, Javascript, CSS"
  },

  /* #5 */

  {
    title: "Razr Motorola media driver development & Integration", 
    year: 2004,
    location: 'IL, FL, Tokyo, United State, Japan',
    detail: "Developed camera, LCD, File System driver interface for global phone product. Localized Motorola product for Japanese Phone carrier - NTT. \
            C, C++, Java"
  },

  /* #6 */

  {
    title: "UrView - Cross platform color bind app", 
    year: 2019,
    location: 'New York, United State',
    detail: "IOS and Android app - UrView - using Native Engine build with OpenCV \
    C, HTML, Javascript, C++, Swift, Kotlin"
  },
  /* #7 */
  {
    title: "Volcano installation", 
    year: 2003,
    location: 'Tokyo, Japan',
    detail: "Volcano installation #1 Machiya Gallery"
  },
  /* #8 */

  {
    title: "Volcano installation", 
    year: 2003,
    location: 'New York, United State',
    detail: "Volcano installation #2 Archip Gallery Theatre"
  }
];

@Component(
{
  props: {
    detailId: Number,
    default : 0
  }, 
  watch: {
    detailId: function( from, to ) {
      this.onDetailIdChanged( from, to );
    }
  }
})
export default class WorkGalleryDetail extends Vue{
  currentTweens = [];

  mounted(){
    this.setAnimation();
  }

  beforeDestroy(){
    console.info( ' canceling work gallery detail ');
    this.invalidatePreviousTransition();
  }
  get detailTitle() {
    return galleryList[ this.detailId ].title;
  }
  get detailYear() {
    return galleryList[ this.detailId ].year;
  }

  get detailLocation() {
    return galleryList[ this.detailId ].location;
  }
  get detailDetail() {
    return galleryList[ this.detailId ].detail;
  }

  onDetailIdChanged( to, from ) {
    console.log('detailID changed' + this.detailId ); 
    this.setAnimation();
  }


  async setAnimation(){
    this.invalidatePreviousTransition();
    const tl = gsap.timeline();
    tl.set("#work_gallery_detail-contents span.slideIn", {
          duration: 0,
          opacity: 0
        })
        .from("#work_gallery_detail-contents", {
          duration: 0.5,
          marginTop: 100,
          opacity: 0,
          clearProps: "all"
        })
        .from("#work_gallery_detail-contents span.slideIn", {
            duration: 1,
            marginLeft: 100,
            opacity: 0,
            ease: "power2.inOut",
            stagger: 0.3,
            clearProps: "all"
        });
      
    this.currentTweens.push(tl);
  }

  invalidatePreviousTransition(){
    while( this.currentTweens.length > 0  ) {
      const tw = this.currentTweens.splice(0,1)[0]
      tw.invalidate();
    }
  }

  // set detailId( _detailId ) {
  //   console.log('detailID is set: ' + _detailId );
  //   this.detailId = _detailId;
  // }
}
</script>

<style lang="scss">
  #work_gallery_detail{
    position: absolute;
    display: flex;
    bottom: 0px;
    height: 50%;
    width: 100%;
    left: 0px;
    justify-content: center;
    align-items: flex-start;

    #work_gallery_detail-contents {
      width: 60%;
      background: rgba(255, 255, 255, 0.5);
      height: 100%;
      padding: 1em;
      box-sizing: border-box;
      overflow: hidden;

      .slideIn{
        position: absolute;
        display:inline-block;
        position: relative;
        width: 100%;

        h1{
          margin: 0px;
        }
        &.yearLoction{
          font-size: 0.9em;
          font-style: italic;
        }
        &.detail {
          margin-top: 2em;
          font-size: 1.25em;
          line-height:1.5em;
        }
      }
    }
  }
  
</style>